<template>
    <div class="horizontal_slider" v-show="list.length > 1">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide"
                    v-for="item in list"
                    :key="item.id"
                    :class="[index == item.id ? 'active' : '']"
                    @click="handleClickSlider(item.id)"
                >{{ item.title }}</div>
            </div>
        </div>
        <div class="swiper_wrapper_right"></div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    props: ['list', 'index'],
    data() {
        return {
            indexList: [],
        }
    },
    methods: {
        getIndexList() {
            this.list.forEach((item, i) => {
                this.indexList[item.id] = i
            })
        },
        initSlider() {
            let horizontalSlider = new Swiper('.swiper-container', {
                slidesPerView: 'auto',
                spaceBetween: 0
            })
            // 跳转到高亮
            horizontalSlider.slideTo(this.indexList[this.index], 800, false)
        },
        handleClickSlider(id) {
            this.$emit('handleClick', id)
        }
    },
    mounted() {
        this.getIndexList()
        this.initSlider()
    }
}
</script>

<style lang="less" scoped>
@import '../../node_modules/swiper/dist/css/swiper.css';
.horizontal_slider {
    width: 100%;
    height: 0.9rem;
    background: #037edb;
    position: relative;
    .swiper-container {
        .swiper-wrapper {
            .swiper-slide {
                color: #fff;
                font-size: 0.29rem;
                line-height: 0.9rem;
                text-align: center;
                width: auto;
                padding: 0 0.25rem;
                // width: 23%;
                &:last-child {
                    margin-right: 0.8rem;
                }
            }
        }
    }
    .swiper_wrapper_right {
        width: 12%;
        height: 0.9rem;
        background: url('../assets/images/menu_right.png') no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 9;
    }
    .active {
        background: #4db62b;
    }
}
</style>